import { MotorService } from '../services/motorService';
import { Helpers } from './helpers';

export class WillHelper {
  constructor() {}

  static processWillLead = async (willsParams) => {
    let sales_agent = await Helpers.getInStorage('sales_agent', true);
    if (sales_agent) {
      sales_agent = JSON.parse(sales_agent)
    }
    const auth_user = await Helpers.getAuthUser();
    const { user_id, will_send_lead, leadDetails } = willsParams;
    try {
      const leadParams = {
        user_id,
        will_send_lead,
        entityObj: {
          ...(sales_agent
            ? {
                entity: 'agent',
                email: sales_agent.email,
              }
            : {
                entity: 'user',
                email: leadDetails?.email || auth_user?.email,
              }),
        },
        leadDetails,
      };
      return await MotorService.processWillLead(leadParams);
    } catch (error) {
      console.log('Error processWillLead', error);
    }
  };
}
